import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[iuDynamicContainer]',
  standalone: true,
})
export class DynamicContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
